import { AmlFlowEnum } from '@/api';

const isFlowLite = (flow: AmlFlowEnum | '' = '') => {
  if (!flow) {
    return false;
  }

  return [AmlFlowEnum.LITE, AmlFlowEnum.LIGHT].includes(flow);
};

export default isFlowLite;
